/* Couchpotato editorial homepage behaviours.
   Idempotent + re-runnable so it works in the Shopify theme editor
   (shopify:section:load) as well as on first paint. No dependencies. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Reveal on scroll -------------------------------------------------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.cp-reveal:not(.cp-in)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cp-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('cp-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* --- Horizontal strips: arrow placement + scroll ----------------------- */
  function initStrips(root) {
    var wraps = (root || document).querySelectorAll('.cp-strip-wrap');
    wraps.forEach(function (wrap) {
      if (wrap.dataset.cpStrip === 'ready') return;
      wrap.dataset.cpStrip = 'ready';

      var strip = wrap.querySelector('.cp-strip');
      if (!strip) return;
      var prev = wrap.querySelector('.cp-snav.cp-prev');
      var next = wrap.querySelector('.cp-snav.cp-next');
      var firstFig = wrap.querySelector('.cp-s-card .cp-figure') || wrap.querySelector('.cp-s-card');

      function step() {
        var card = strip.querySelector('.cp-s-card');
        var gap = parseFloat(getComputedStyle(strip).columnGap || getComputedStyle(strip).gap || '16') || 16;
        return card ? card.getBoundingClientRect().width + gap : strip.clientWidth * 0.8;
      }

      function place() {
        var overflowing = strip.scrollWidth > strip.clientWidth + 4;
        var top = null;
        if (firstFig) {
          var wr = wrap.getBoundingClientRect(), fr = firstFig.getBoundingClientRect();
          top = (fr.top - wr.top) + fr.height / 2;
        }
        [prev, next].forEach(function (b) {
          if (!b) return;
          b.style.display = overflowing ? 'inline-flex' : 'none';
          if (top !== null) b.style.top = top + 'px';
        });
      }

      if (prev) prev.addEventListener('click', function () { strip.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { strip.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });

      window.addEventListener('resize', place);
      window.addEventListener('load', place);
      place();
    });
  }

  /* --- Shop-the-look hotspots -------------------------------------------- */
  function initHotspots(root) {
    var btns = (root || document).querySelectorAll('.cp-hs-item .cp-hs');
    btns.forEach(function (btn) {
      if (btn.dataset.cpHs === 'ready') return;
      btn.dataset.cpHs = 'ready';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var item = btn.closest('.cp-hs-item');
        var was = item.classList.contains('cp-open');
        document.querySelectorAll('.cp-hs-item.cp-open').forEach(function (o) { o.classList.remove('cp-open'); });
        if (!was) item.classList.add('cp-open');
      });
    });
    if (!document.body.dataset.cpHsOutside) {
      document.body.dataset.cpHsOutside = '1';
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.cp-hs-item')) {
          document.querySelectorAll('.cp-hs-item.cp-open').forEach(function (o) { o.classList.remove('cp-open'); });
        }
      });
    }
  }

  function initAll(root) { initReveal(root); initStrips(root); initHotspots(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Theme editor: re-init a section when it is added/reloaded */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
